<script setup>
import {ref, computed} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useNavigationStore} from '@/stores/navigation'
import {useUserStore} from '@/stores/user'
import {useModalsStore} from '@/stores/modals'
import {useAppStore} from '@/stores/appStore'
import Button from '@/common/Button.vue'

const props = defineProps({
    groupName: String
})

const route = useRoute()
const router = useRouter()
const appStore = useAppStore()
const navigationStore = useNavigationStore()
const userStore = useUserStore()
const modalsStore = useModalsStore()

const button = ref(null)

const user = computed(() => userStore.user)

const components = computed(() => {
    return navigationStore.components
        .filter(o => o.navigationGroup === props.groupName)
})

const activeGroup = computed(() => {
    let component = components.value
        .find(o => o.tableName === appStore.navigationComponent)

    if (component) {
        return component.navigationGroup
    }

    switch (route.name) {
        case 'themesEditor':
            return 'Themes'
        case 'siteTree':
            return 'Website'
    }
    return null
})

const formAdmin = computed(() => {
    return (
        props.groupName === 'Forms'
        && (user.value?.administrator || user.value?.access?.__formAdmin)
    )
})

const show = computed(() => {
    return (
        components.value
        && (
            components.value.length
            || (props.groupName === 'Forms' && formAdmin.value)
        )
    )
})

const goTo = (tableName) => {
    button.value?.$el?.click()

    switch (tableName) {
        case 'm_basket_reports':
            router.push({name: 'salesReports'})
            break
        case 'site_tree':
            router.push({name: 'siteTree'})
            break
        case 'editor':
            router.push({name: 'pageEditor'})
            break
        case 'themes_editor':
            router.push({name: 'themesEditor'})
            break
        default:
            router.push({name: 'list', params: {component: tableName}})
    }
}

const openNewContentTypeModal = (isForm) => {
    modalsStore.show({
        componentName: 'NewContentTypeModal',
        obj: {isForm}
    })
}

const createContentTypeAccess = () => {
    return (props.groupName === 'Add ons' && user.value?.administrator)
}
</script>

<template>
    <div v-show="show" class="dropdown">
        <Button ref="button" :class="{ active: groupName === activeGroup }" class="px-3 h-100 btn-sm rounded-0"
                data-bs-toggle="dropdown">
            {{ groupName }}
        </Button>

        <div class="dropdown-menu">
            <button v-for="component in components" :key="component.id"
                    :class="{ active: appStore.navigationComponent === component.tableName }" class="dropdown-item"
                    type="button" @click="goTo(component.tableName)">
                {{ component.title }}
            </button>

            <button v-if="formAdmin" class="dropdown-item" type="button"
                    @click="openNewContentTypeModal(true)">
                + New form
            </button>

            <button v-if="createContentTypeAccess()" class="dropdown-item" type="button"
                    @click="openNewContentTypeModal()">
                + New collection
            </button>
        </div>
    </div>
</template>